"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertItemListToTrees = void 0;
var data_structures_1 = require("@tableau/data-structures");
var DestinationItem_1 = require("./DestinationItem");
var NestedItemsFractalRowStore_1 = require("./NestedItemsFractalRowStore");
/**
 *  Re-implemented from lodash/underscore so we don't have to depend on the entire library,
 *  which bloats the file size of the module
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function groupBy(items, getKey) {
    var result = {};
    items.forEach(function (item) {
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        var key = '' + getKey(item);
        if (Object.prototype.hasOwnProperty.call(result, key)) {
            result[key].push(item);
        }
        else {
            result[key] = [item];
        }
    });
    return result;
}
var undefinedString = 'undefined';
/**
 * The input list of project/location objects implies a hierarchy (based on the parentItemId field),
 * but projects' children could be anywhere in the array relative to their parent. This function
 * converts such a flat list into a tree that represents the hierarchy and preserves siblings'
 * ordering relative to each other.
 */
function convertItemListToTrees(items) {
    var topLevelItems = items.filter(function (item) { return item.topLevelItem; });
    var itemsByParent = groupBy(items, function (p) { return p.parentId; });
    function buildDescendantTreeFromItem(item, nestingLevel) {
        var _a;
        var childItems = itemsByParent[item.id];
        delete itemsByParent[item.id];
        return new data_structures_1.RoseTree(convertItemToBasicInfo(item, nestingLevel), (_a = childItems === null || childItems === void 0 ? void 0 : childItems.map(function (childItem) { return buildDescendantTreeFromItem(childItem, nestingLevel + 1); })) !== null && _a !== void 0 ? _a : []);
    }
    // Root nesting level is 1 because the top-level items are all children of the site,
    // which occupies level 0 in the nested items datagrid.
    var topLevelItemsTree = topLevelItems ? topLevelItems.map(function (p) {
        return buildDescendantTreeFromItem(p, p.itemType === DestinationItem_1.DestinationItemType.personalSpace ? 0 : 1);
    }) : [];
    /**
     * Now we have to find the orphaned items that do not have a parent (because they don't have permission)
     * and group them together under a 'permissions required' top level item.
     */
    // remove the 'site' container item (that holds all top level items) that is represented
    // by 'undefined' as parent item id.
    delete itemsByParent[undefinedString];
    // Find all orphaned parent items
    var leftOverParentItemIds = Object.keys(itemsByParent).reduce(function (result, key) {
        var ids = itemsByParent[key].map(function (p) { return p.id; });
        return result.concat(ids);
    }, []);
    // Find all orphaned (parent or leaf node) items that do not have a parent to build a tree from
    var orphanedParentItems = items.filter(function (item) {
        return leftOverParentItemIds.indexOf(item.id) !== -1 &&
            (item.parentId !== undefined && leftOverParentItemIds.indexOf(String(item.parentId)) === -1);
    });
    // Create a tree from the orphaned parent items
    // We will be adding a "top level permissions required item" so start nesting at 2
    var orphanedItemsTree = orphanedParentItems.map(function (p) { return buildDescendantTreeFromItem(p, 2); });
    if (orphanedItemsTree.length > 0) {
        // Set the top level node to isOrphaned = true.
        // This is needed so we can attach this tree to the "permissions required" node when we print it out.
        orphanedItemsTree.forEach(function (p) {
            if (p.node.nestingLevel === 2) {
                // these are the top most level orphaned parents.
                p.node.isOrphaned = true;
            }
        });
        // Add the 'permission required' node on the orphaned items.
        var permissionsRequiredTree = new data_structures_1.RoseTree(NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.permissionsRequiredItemContainer(), orphanedItemsTree);
        return topLevelItemsTree.concat(permissionsRequiredTree);
    }
    return topLevelItemsTree;
}
exports.convertItemListToTrees = convertItemListToTrees;
function convertItemToBasicInfo(item, nestingLevel) {
    return {
        id: item.id,
        parentId: item.parentId,
        name: item.name,
        nestingLevel: nestingLevel,
        hasChildren: item.childItemCount > 0,
        status: item.status,
        itemType: item.itemType,
    };
}
//# sourceMappingURL=NestedItemsTreeHelper.js.map